import { COLORS } from '@constants';
import styled, { css } from 'styled-components';

export const StyledWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    background-color: ${COLORS.$white};

    width: 100%;
    margin: 0 6px;

    ${({ $isHomePage }) =>
        $isHomePage
            ? css`
                  border-radius: 4px;
                  border: 1px solid ${COLORS.$gray15Black};
                  padding: 16px;
              `
            : null};
`;

export const StyledImage = styled.img`
    width: 89px;
    height: 89px;
    object-fit: cover;
    margin-bottom: 16px;

    ${({ $isHomePage }) =>
        $isHomePage
            ? css`
                  width: 149px;
                  height: 149px;
              `
            : null};
`;
